import classNames from 'classnames'

export function withIcon(iconName: string, className: string, size?: string): string {
  return classNames(
    className,
    `${iconName} before:content-[''] before:bg-contain before:bg-no-repeat before:bg-center`,
    size || 'before:h-full before:w-full',
  )
}